import createSvgIcon from "./utils/create_icon"

const FrameSizeLarge = createSvgIcon(<path clipRule="evenodd" d="M18 5H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zM6 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3z" fill="currentColor" fillRule="evenodd" />, "FrameSizeLarge")
export default FrameSizeLarge
